import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { Notification } from "../interfaces/Notification";

interface notificationState {
  notifications: Array<Notification>;
  selectedNotification?: Notification;
}

const initialState: notificationState = {
  notifications: [],
};

const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setAllNotifications: (state, action: PayloadAction<Notification[]>) => {
      state.notifications = action.payload;
    },
    setSelectedNotification: (
      state,
      action: PayloadAction<Notification | undefined>
    ) => {
      state.selectedNotification = action.payload;
    },
  },
});

export const { setAllNotifications, setSelectedNotification } =
  notificationSlice.actions;
export default notificationSlice.reducer;
